import { registerPlugin } from '@capacitor/core';

import { KeyboardShortcutPlugin } from './definitions';
import { CAPACITOR_KEYBOARD_SHORTCUT_NAME } from '../pluginConstants';

const KeyboardShortcut = registerPlugin<KeyboardShortcutPlugin>(CAPACITOR_KEYBOARD_SHORTCUT_NAME);

export * from './definitions';
export { KeyboardShortcut };
